"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledButton = styled_components_1.default.button `
  background-color: ${tokens.ColorWhite000};
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  border-radius: 4px;
  padding: ${props => (props.icon ? "8px 16px 8px 16px" : "8px 24px 8px 24px")};
  border: none;
  outline: none;
  height: 40px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left:${props => props.marginLeftPx ? props.marginLeftPx + "px" : "0px"}
  margin-right:${props => props.marginRightPx ? props.marginRightPx + "px" : "0px"}
  width: ${props => (props.fitContainerWidth ? "100%" : "auto")}
  @media only screen and (max-width: 768px) {
    height: 48px;
  }

  ${(props) => props.buttonType === "primary" &&
    styled_components_1.css `
      box-shadow: 0px 4px 4px rgba(45, 57, 64, 0.08),
        0px 0px 2px rgba(45, 57, 64, 0.12);
      background-color: ${props.disabled
        ? tokens.ColorWhite050
        : tokens.ColorBrandInteractiveBlue}};
      color: ${props.disabled ? tokens.ColorGrey400 : tokens.ColorWhite000};
      ${!props.disabled &&
        `:hover, :focus {
        background-color: ${tokens.ColorBrandInteractiveBlueHover};
      }`}
        :active {
        background-color: ${tokens.ColorBrandInteractiveBluePressed};
      }
    `}
  ${(props) => props.buttonType === "alert" &&
    styled_components_1.css `
      box-shadow: 0px 4px 4px rgba(45, 57, 64, 0.08),
        0px 0px 2px rgba(45, 57, 64, 0.12);
      background-color: ${props.disabled
        ? tokens.ColorWhite050
        : tokens.ColorFunctionalRed500}};
      color: ${props.disabled ? tokens.ColorGrey400 : tokens.ColorWhite000};
      ${!props.disabled &&
        `:hover, :focus {
        background-color: ${tokens.ColorFunctionalRed700};
      }`}
        :active {
        background-color: ${tokens.ColorFunctionalRed900};
      }
    `}
    ${(props) => props.buttonType === "secondaryAlert" &&
    styled_components_1.css `
        color: ${props.disabled
        ? tokens.ColorGrey400
        : tokens.ColorFunctionalRed500};
        background: transparent;
        border: ${props.disabled
        ? `1px solid ${tokens.ColorGrey400}`
        : `1px solid ${tokens.ColorFunctionalRed500}`};
        ${!props.disabled &&
        `:hover, :focus {
          background-color: ${tokens.ColorWhite050};
          color: ${tokens.ColorFunctionalRed500};
        }`}
          :active {
          background-color: ${tokens.ColorFunctionalRed500};
          color: ${tokens.ColorWhite000};
        }
      `}
  ${(props) => props.buttonType === "secondary" &&
    styled_components_1.css `
      color: ${props.disabled
        ? tokens.ColorGrey400
        : tokens.ColorBrandInteractiveBlue};
      background: transparent;
      border: ${props.disabled
        ? `1px solid ${tokens.ColorGrey400}`
        : `1px solid ${tokens.ColorBrandInteractiveBlue}`};
      ${!props.disabled &&
        `:hover, :focus {
        background-color: ${tokens.ColorWhite050};
        color: ${tokens.ColorBrandInteractiveBlue};
      }`}
        :active {
        background-color: ${tokens.ColorBrandInteractiveBlue};
        color: ${tokens.ColorWhite000};
      }
    `}
  ${(props) => props.buttonType === "textButton" &&
    styled_components_1.css `
      color: ${props.disabled
        ? tokens.ColorGrey400
        : tokens.ColorBrandInteractiveBlue};
      border: 1px solid transparent;
      background: transparent;
      ${!props.disabled &&
        `:hover, :focus {
            border: ${props.disabled
            ? `1px solid ${tokens.ColorGrey400}`
            : `1px solid ${tokens.ColorBrandInteractiveBlue}`};
        }`}
        :active {
        background-color: ${tokens.ColorBrandInteractiveBlue};
        color: ${tokens.ColorWhite000};
      }
    `}
`;
const StyledButtonText = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;
/**
 * Use `Button` to highlight key info with a predefined status.
 */
class Button extends react_1.Component {
    render() {
        const _a = this.props, { type, title, disabled, fitContainerWidth, onClick, icon } = _a, rest = __rest(_a, ["type", "title", "disabled", "fitContainerWidth", "onClick", "icon"]);
        return (react_1.default.createElement(StyledButton, Object.assign({ tabindex: 0, buttonType: type || "primary", disabled: disabled, fitContainerWidth: fitContainerWidth, onClick: onClick, icon: icon }, rest),
            react_1.default.createElement(StyledButtonText, null,
                icon && (react_1.default.createElement("img", { style: { marginRight: 8 }, src: `data:image/svg+xml;base64,${icon}`, width: "16px", height: "16px", alt: title + ' Button' })),
                title || "Button")));
    }
}
exports.default = Button;
//# sourceMappingURL=Button.js.map